export enum InvoiceTypeEnum {
    Balance = 'balance',
    Classic = 'classic',
    CreditNote = 'credit_note',
    Downpayment = 'downpayment',
    Proforma = 'proforma',
    Situation = 'situation',
}